// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useTestId = (prefix, props) => {
    const isTestOrDevelopment = !process.env.NODE_ENV || ['test', 'development'].includes(process.env.NODE_ENV);
    return (str) => {
        if (!isTestOrDevelopment)
            return {};
        // overwrite given prefix if data-testid exist in parameters
        if (props === null || props === void 0 ? void 0 : props['data-testid'])
            prefix = props['data-testid'];
        if (str || prefix) {
            const dataTestID = `${prefix || ''}${str && prefix ? '-' : ''}${str || ''}`;
            return { 'data-testid': dataTestID.replace(/[\s_]+/g, '-') };
        }
        return {};
    };
};
//# sourceMappingURL=useTestId.js.map